module.exports = __webpack_public_path__ + "img/n4.ead11a86.png";